export default __webpack_public_path__ + "static/media/auth-screen-illustration-2.3cd02810.svg";